var render, staticRenderFns
import script from "./myClientEdit.vue?vue&type=script&lang=js"
export * from "./myClientEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd8d638",
  null
  
)

export default component.exports